import React, { forwardRef, Ref } from 'react';

import { scrollTargetStyle } from '../../constants/style';
import FormSection from '../forms/FormSection';
import ProductsList from '../Products/ProductsList';

interface AdGroupProductsSectionProps {
  advertiserId: number;
}

function AdGroupProductsSection(props: AdGroupProductsSectionProps, ref: Ref<HTMLDivElement>) {
  const { advertiserId } = props;

  return (
    <FormSection>
      <div ref={ref} style={scrollTargetStyle} />
      <ProductsList advertiserId={advertiserId} />
    </FormSection>
  );
}

export default React.memo(forwardRef(AdGroupProductsSection));
